import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import ProfileEditNotesPage from '/component/partial/profile/ProfileEditNotesPage';
import {CLIENT_NOTES_STATE_IS_LOADING} from '/enum/clients.enum';
import {USER_TYPES} from '/enum/tealium.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {
  setClientNotesState,
  updateClientNotes,
} from '/redux/action/client.action';
import {notesById, notesUpdatedTsById} from '/redux/selector/client.selector';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withHOC} from '/util/hoc.util';
import {fromProps, withProps} from '/util/selector.util';
const withClientId = withProps({
  clientId: fromProps(get('recordId')),
});
export default withHOC(
  connect(
    createStructuredSelector({
      notes: withClientId(notesById),
      notesUpdatedTs: withClientId(notesUpdatedTsById),
      userId,
      lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    }),
    dispatch => ({
      updateClientNotes: ({clientId, body}: any) =>
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        dispatch(updateClientNotes({clientId, body})),
      setClientNotesState: ({clientId, stateName, stateValue}: any) =>
        dispatch(
          // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
          setClientNotesState({
            clientId,
            stateName,
            stateValue,
          }),
        ),
    }),
    (stateProps, dispatchProps, ownProps) => {
      const {recordId: clientId} = ownProps;
      return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        userType: USER_TYPES.client,
        updateNotes: ({body}: any) => {
          return dispatchProps.updateClientNotes({clientId, body});
        },
        setState: () => {
          return dispatchProps.setClientNotesState({
            clientId,
            stateName: CLIENT_NOTES_STATE_IS_LOADING,
            stateValue: true,
          });
        },
      };
    },
  ),
  withTranslation('screen.clientProfile.section.editNotes'),
)(ProfileEditNotesPage);
